import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector, useDispatch } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { setInstallerDeclarationAccepted } from '../../features/installer/installerJourneySlice';
import useTitle from '../../hooks/useTitle';

const DeclarationInstaller = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const dispatch = useDispatch();

  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const history = useHistory();
  useTitle(
    'installer.DeclarationInstaller.s15',
    'Declaration - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const handleBtnClick = () => {
    dispatch(setInstallerDeclarationAccepted(true));
    history.push('/installer/subcontractor');
  };

  return (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'installer.DeclarationInstaller.s1',
          'Declaration'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.DeclarationInstaller.s2',
          'By continuing, you confirm that you:'
        )}
      </p>
      <ul className="govuk-list govuk-list--bullet">
        <li>
          {copyProvider.getCopy(
            'installer.DeclarationInstaller.s3',
            'will provide the correct information to the best of your knowledge'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'installer.DeclarationInstaller.s4',
            'installed the chargepoints in a private car parking area'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'installer.DeclarationInstaller.s5',
            'have conducted a survey prior to installation'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'installer.DeclarationInstaller.s6',
            'completed the BS7671 Electrical Installation Certificate'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'installer.DeclarationInstaller.s7',
            'notified the local Distribution Network Operator (DNO) of this installation'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'installer.DeclarationInstaller.s8',
            'agree to work with OZEV or its agents should the installation be chosen for audit'
          )}
        </li>
      </ul>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.DeclarationInstaller.s9',
          'You also confirm that when installing a chargepoint, you will consider accessibility and mobility needs of EV owners.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.DeclarationInstaller.s10',
          'Your information will be handled in accordance with the'
        )}{' '}
        <a
          href="https://www.gov.uk/government/organisations/office-for-low-emission-vehicles/about/personal-information-charter"
          target="_blank"
          className="govuk-link"
          rel="noreferrer"
        >
          {copyProvider.getCopy(
            'installer.DeclarationInstaller.s11',
            'OZEV personal information charter '
          )}
          <span>
            {copyProvider.getCopy(
              'installer.DeclarationInstaller.s12',
              '(opens in new tab)'
            )}
          </span>
        </a>
      </p>
      <div className="govuk-warning-text govuk-!-margin-top-7">
        <span className="govuk-warning-text__icon" aria-hidden="true">
          !
        </span>
        <strong className="govuk-warning-text__text">
          <span className="govuk-warning-text__assistive">Warning</span>
          <b>
            {copyProvider.getCopy(
              'installer.DeclarationInstaller.s13',
              'It is an offence to make a false declaration to obtain a grant and you could be fined or prosecuted.'
            )}
          </b>
        </strong>
      </div>
      <Button
        className="govuk-button-group govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'installer.DeclarationInstaller.s14',
          'Agree and continue'
        )}
      </Button>
    </>
  );
};

export default DeclarationInstaller;
